export default{
    getCustomColors: state => {
        // return state.colors ? state.colors : JSON.parse(localStorage.getItem('colors'))
        return JSON.parse(localStorage.getItem('colors'))
    },
    getEssentialInfo: state =>{
        return state.info.workspaceId ? state.info : JSON.parse(localStorage.getItem('info'))
    },
    getUserInfo: state =>{
        return state.userInfo.id ? state.userInfo : JSON.parse(localStorage.getItem('userInfo'))
    }
}